module.exports = __webpack_public_path__ + "static/media/paypal.fcd8b1e8.png";